/**
 * 检测当前是否为纯血鸿蒙系统
 *
 * 判断逻辑：
 * 1. 检查是否包含鸿蒙标识
 *    - HarmonyOS
 *    - OpenHarmony
 * 2. 排除套皮鸿蒙
 *    - 不包含 Android 标识
 *
 * @returns {boolean} 如果是纯血鸿蒙系统返回 true，否则返回 false
 *
 * @example
 * ```ts
 * if (isHarmony()) {
 *   useHarmonyNativeAPI();
 * }
 * ```
 */
export function isHarmony(): boolean {
  try {
    if (typeof navigator === "undefined" || !navigator.userAgent) {
      return false;
    }

    const ua = navigator.userAgent.toLowerCase();

    // 鸿蒙系统检测
    // 注意：这里的 UA 已经做了 toLowerCase，所以标识符也应保持小写
    const harmonyIdentifiers = [
      "harmonyos",
      "openharmony",
      "hongmeng",
      "hexin_harmonyos",
    ];

    // 排除标识（套皮鸿蒙特征）
    const excludeIdentifiers = ["android"];

    return (
      // 包含鸿蒙标识
      harmonyIdentifiers.some((keyword) => ua.includes(keyword)) &&
      // 且不包含排除标识
      !excludeIdentifiers.some((keyword) => ua.includes(keyword))
    );
  } catch (error) {
    console.warn("检测鸿蒙系统失败:", error);
    return false;
  }
}
